import React from "react";
import { STATUS_META } from "@/lib/brand";

export default function StatusBadge({ status, className = "", size = "sm" }) {
  const m = STATUS_META[status] || STATUS_META.pending;
  const pad = size === "lg" ? "px-4 py-1.5 text-base" : "px-2.5 py-1 text-xs";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1 border-2 border-ink font-bold uppercase tracking-wide ${m.bg} ${m.text} ${pad} ${className}`}
    >
      {m.icon && <span aria-hidden>{m.icon}</span>}
      {m.label}
    </span>
  );
}
